import { render, staticRenderFns } from "./CheckBoxGridItem.vue?vue&type=template&id=298fd651&"
import script from "./CheckBoxGridItem.vue?vue&type=script&lang=js&"
export * from "./CheckBoxGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports